import styled from "styled-components";
import { LAYER_COLORS, TEXT_COLORS } from "../../constants/design/colors";
import { FONT_CSS } from "../../constants/design/fontSize";
import { SPACING } from "../../constants/design/spacing";

/**
 * Outer flex column for the trading-mode embed (used inside the
 * bottom-bar drawer). The drawer's `ContentContainer` is `overflow: hidden`
 * and has a definite height from its flex parent, so a 100%-height flex
 * column inside it gives the table area a real height to fill.
 */
export const TradingShell = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

/**
 * The scroll surface inside `TradingShell`. Owns `overflow-y: auto`, so
 * IntersectionObserver picks it as its root (via `findScrollParent`) and
 * the user actually scrolls the rows instead of having them clipped.
 */
export const TradingScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const LoadMoreRow = styled.tr`
  background-color: transparent !important;
  cursor: default !important;
  &:hover {
    background-color: transparent !important;
  }
  td {
    background-color: transparent !important;
    padding: ${SPACING.three}px 0 !important;
  }
`;

export const LoadMoreSentinel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: ${SPACING.three}px 0;
`;

export const HistoryTabsHeader = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING.three}px;
  padding: ${({ isMobile }) =>
    isMobile ? `${SPACING.two}px 0` : `${SPACING.three}px ${SPACING.five}px`};
  border-bottom: 1px solid ${LAYER_COLORS.two};
`;

export const HistoryTabsHeaderTitle = styled.div`
  ${FONT_CSS.label.three}
  color: ${TEXT_COLORS.one};
  text-transform: uppercase;
`;

export const HistoryTabsHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${SPACING.two}px;
`;

/**
 * Secondary "(TP Triggered)" / "(Liquidated)" note appended to the Type cell.
 * Muted so the base action stays the primary read.
 */
export const ExitReasonNote = styled.span`
  color: ${TEXT_COLORS.three};
  margin-left: ${SPACING.one / 2}px;
`;

/**
 * "Open this tx on the block explorer" affordance in a history row. A real
 * anchor, so it is focusable and openable in a new tab; the row's own click
 * (details modal) is left intact by stopping propagation at the call site.
 */
export const ExplorerLink = styled.a`
  ${FONT_CSS.body.six}
  display: inline-flex;
  align-items: center;
  margin-right: ${SPACING.two}px;
  color: ${TEXT_COLORS.two};
  text-decoration: none;

  &:hover {
    color: ${TEXT_COLORS.one};
  }
`;

export const PositionEffectTag = styled.span<{ effect?: string }>`
  ${FONT_CSS.body.six}
  display: inline-flex;
  align-items: center;
  padding: ${SPACING.one / 2}px ${SPACING.one}px;
  border-radius: 4px;
  text-transform: capitalize;
  background-color: ${LAYER_COLORS.two};
  color: ${TEXT_COLORS.two};
`;
